import type { MotorSumInsuredResponse } from "@/D2C/features/car-quote/redux/motor-suminsured/motorSumInsuredSlice";

export type MotorSumInsuredRange = {
  min: number;
  max: number;
};

export function normalizeCurrencyInput(value: string | number | null | undefined) {
  return String(value ?? "").replace(/[^\d]/g, "");
}

export function formatCurrencyValue(value: string | number | null | undefined) {
  const normalizedValue = normalizeCurrencyInput(value);

  if (!normalizedValue) {
    return "";
  }

  return new Intl.NumberFormat("en-US").format(Number(normalizedValue));
}

export function normalizeMotorSumInsuredResponse(payload: unknown): MotorSumInsuredResponse {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return {};
  }

  return Object.entries(payload as Record<string, unknown>).reduce<MotorSumInsuredResponse>(
    (accumulator, [key, value]) => {
      const normalizedValue =
        typeof value === "number"
          ? value
          : typeof value === "string"
            ? Number(normalizeCurrencyInput(value))
            : Number.NaN;

      if (Number.isFinite(normalizedValue) && normalizedValue > 0) {
        accumulator[key] = normalizedValue;
      }

      return accumulator;
    },
    {}
  );
}

export function getMotorSumInsuredRange(
  data: MotorSumInsuredResponse | null | undefined
): MotorSumInsuredRange | null {
  const values = Object.values(data ?? {}).filter(
    (value): value is number => Number.isFinite(value) && value > 0
  );

  if (!values.length) {
    return null;
  }

  values.sort((left, right) => left - right);

  return {
    min: values[0],
    max: values[values.length - 1],
  };
}
